<template>
	<div
		class="inset-0 bg-white/50 flex items-center justify-center p-4 z-10"
		:class="{
    'absolute': !fixed,
    'fixed': fixed,
  }"
	>
		<LoadingIndicator :size="size" />
	</div>
</template>

<script lang="ts" setup>
import LoadingIndicator from '@/components/LoadingIndicator.vue';

export interface Props {
  size?: number
  fixed?: boolean
}

withDefaults(defineProps<Props>(), {
  fixed: false,
  size: undefined,
});
</script>
